<template>
  <div class="loader-fullscreen-wrapper">
    <AntSpin size="large" />
  </div>
</template>

<script>
import { Spin as AntSpin } from 'ant-design-vue';

export default {
  name: 'LoaderFullscreen',
  components: { AntSpin },
};
</script>

<style lang="scss" scoped>
  .loader-fullscreen-wrapper {
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
